import React from 'react';
import SortIcon from 'components/molecules/common/Icon/SortIcon';

interface IProps {
    headerColumns: TableHeader[];
    level?: string;
}
export interface TableHeader {
    key: string;
    label: string;
    allowSort: boolean;
}

const OptimizePlanTableHeader: React.FC<IProps> = ({ headerColumns, level }) => {
    return (
        <div className="flex gap-4 bg-backgroundGreyAlt1">
            {headerColumns.map((item: TableHeader) => (
                <div key={item.key} className={`flex items-center justify-between flex-1 p-4`}>
                    <div className={`${item.key !== 'kpi' ? 'm-auto' : ''}`}>{item.label}</div>
                    {item.allowSort && <SortIcon onClick={() => {}} />}
                </div>
            ))}
            {level && level !== 'category' && <div className="w-12" />}
        </div>
    );
};

export default React.memo(OptimizePlanTableHeader);
